import { useMemo } from 'react';

import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { Typography } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';
import { CouponContext } from '@/domains/loyalty/components/Coupon/CouponContext';
import { HighlightedCoupon } from '@/domains/loyalty/modules/HighlightedCoupon/HighlightedCoupon';
import { useHighlightedCoupon } from '@/domains/loyalty/modules/HighlightedCoupon/hooks/useHighlightedCoupon';
import { containerTitle } from '@/domains/loyalty/modules/HighlightedCoupon/translations';
import { BlockV2 } from '@/domains/productDiscovery/ProductPage/b2c/components/Block/Block';
import { StringAbTests } from '@/domains/productDiscovery/ProductPage/constants';
import { AdvantagesCard } from '@/productDiscovery/ProductPage/common/components/Advantages/AdvantagesCard/AdvantagesCard';

export const HighlightedCouponContainer: React.FC = () => {
  const {
    amount,
    code,
    context,
    minPurchase,
    percent,
    validUntil,
    label,
    title,
    description,
  } = useHighlightedCoupon();

  const contextProviderData = useMemo(
    () => ({ amount, code, context, minPurchase, percent, validUntil }),
    [amount, code, context, minPurchase, percent, validUntil],
  );

  const [isProductPageRevampEnabled] = useBooleanFlags([
    StringAbTests.ENABLE_PRODUCT_PAGE_REVAMP,
  ]);

  if (!code) return null;

  if (isProductPageRevampEnabled) {
    return (
      <CouponContext.Provider value={contextProviderData}>
        <AdvantagesCard>
          <HighlightedCoupon
            label={label}
            title={title}
            description={description}
          />
        </AdvantagesCard>
      </CouponContext.Provider>
    );
  }

  return (
    <CouponContext.Provider value={contextProviderData}>
      <BlockV2>
        <Typography scale="body1" weight="bold" className="mb-s">
          {containerTitle}
        </Typography>
        <HighlightedCoupon
          label={label}
          title={title}
          description={description}
        />
      </BlockV2>
    </CouponContext.Provider>
  );
};

HighlightedCouponContainer.displayName = 'HighlightedCouponContainer';
